export default class DataSource {
  constructor({ label, url }) {
    this.label = label;
    this.url = url;
  }
}
